import React from "react";
import { MainLayout } from "../../MainLayout";
import { QatarSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const Qatar = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/qatar-air.png",
            sliderimg: [
                { id: 1, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Unveiled%20Heritage/Unveiled_Heritage_3.webp", title: "Unveiled Heritage" },
                { id: 2, img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Unveiled%20Heritage/Unveiled_Heritage_2.webp", title: "Adventure" },
            ],
            title: "3N/4D Unveiled Heritage, Adventure & Luxury",
            days: "3N/4D",
            tags: ["WaterFall", "Temples", "Sightseeing"],
            description:
                "Explore Qatar’s rich heritage, thrilling desert adventures, and luxurious modern attractions in this perfectly balanced 3 Nights / 4 Days getaway. Witness iconic landmarks, enjoy cultural experiences, relax at premium spots, and end your journey with unforgettable memories of Doha.",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Unveiled%20Heritage/Unveiled_Heritage_2.webp",
            slug: "unveiledHeritageAdventureLuxury",
        },
        {
            title: "5N/6D Qatar – In-Depth Itinerary",
            days: "5N/6D",
            // tags: ["Sightseeing", "Mountain", "Lakes"],
            description:
                "Discover Qatar like never before with this immersive 5 Nights / 6 Days experience covering history, culture, adventure, beaches, luxury, and modern city vibes. From UNESCO sites to desert camping, coastal fun, and world-class shopping—this itinerary offers the ultimate Qatar exploration.",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/In%20Depth%20Qatar/In_Depth_Qatar_2.webp",
            slug: "qatarInDepthItinerary",
        },
        {
            title: "4N/5D Explore Qatar from Historic Forts to Desert Dunes",
            days: "4N/5D",
            // tags: ["WildLife", "Boat House", "WaterFall"],
            description: "Journey through Qatar’s timeless heritage as you explore ancient forts, vibrant souqs, and cultural landmarks. Experience the thrill of desert dunes, stunning landscapes, and breathtaking sunsets. This itinerary blends history, adventure, and authentic Qatari charm for a memorable getaway.",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Explore%20Qatar/Explore_Qatar_2.webp",
            slug: "exploreQatarFromHistoricFortsToDesertDunes",
        },

    ];

    const topcitydata = [
        {
            id: 1,
            title: "Doha Corniche",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/doha%20corniche.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A stunning 7-kilometer waterfront
                    promenade offering panoramic views of Doha’s skyline and the Arabian
                    Gulf. A perfect place for evening strolls and romantic dhow cruises.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Dhow Boat Rides, MIA Park, Pearl
                    Monument, Al Dafna skyline views, Corniche Cycling Path, National
                    Museum of Qatar (nearby), Katara Cultural Village, Al Bidda Park,
                    Traditional Cafés.
                </p>,
            ],
        },
        {
            id: 2,
            title: "Souq Waqif",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/souq%20waqif.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A traditional marketplace filled with
                    Qatari culture, aromatic spices, handcrafted jewelry, and lively cafés
                    that preserve the country’s authentic charm.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Spice Market, Falcon Souq, Gold
                    Souq, Local Handicrafts, Shisha Lounges, Traditional Eateries, Art
                    Galleries, Camel Pen, Live Music Nights.
                </p>,
            ],
        },
        {
            id: 3,
            title: "Museum of Islamic Art",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/Museum%20of%20Islamic%20Art.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A world-class museum showcasing centuries
                    of Islamic art and culture, set on its own island with breathtaking
                    architecture designed by I.M. Pei.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Islamic Manuscripts, Ceramics
                    Collection, Rare Textiles, Sculpture Gallery, MIA Park, Art Workshops,
                    Café with Corniche View, Guided Tours.
                </p>,
            ],
        },
        {
            id: 4,
            title: "The Pearl-Qatar",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/The%20Pearl-Qatar.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A luxurious man-made island known for its
                    Mediterranean-inspired marinas, boutique shopping, and waterfront
                    dining experiences.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Porto Arabia, Qanat Quartier, Marina
                    Walk, Luxury Residences, Waterfront Restaurants, High-End Boutiques,
                    Scenic Boat Tours, Art Installations.
                </p>,
            ],
        },
        {
            id: 5,
            title: "Katara Cultural Village",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/Katara%20Cultural%20Village.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>The cultural heart of Doha, Katara is home
                    to art galleries, amphitheaters, and festivals that celebrate Qatar’s
                    creative and artistic identity.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Katara Amphitheatre, Katara Beach,
                    Art Galleries, Opera House, Cafés, Cultural Festivals, Planetarium,
                    Souq Al Katara.
                </p>,
            ],
        },
        {
            id: 6,
            title: "Lusail City",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/Lusail%20City.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Qatar’s futuristic smart city, designed
                    for innovation and sustainability, blending modern architecture with
                    entertainment and leisure.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Lusail Marina, Place Vendôme Mall,
                    Lusail Stadium, Waterfront Promenade, Luxury Hotels, Indoor Theme
                    Park, Cinemas, Marina Cruises.
                </p>,
            ],
        },
        {
            id: 7,
            title: "Inland Sea (Khor Al Adaid)",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Inland%20Sea.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A UNESCO-recognized natural wonder where
                    the desert meets the sea. Make sure to try dune bashing, desert camps,
                    and group adventures.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>4x4 Dune Drives, Camel Rides,
                    Sandboarding, Desert Camp BBQ, Stargazing, Photography Spots, Sunset
                    Views, Traditional Performances.
                </p>,
            ],
        },
        {
            id: 8,
            title: "National Museum of Qatar",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/National%20Museum%20of%20Qatar.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Designed by architect Jean Nouvel, this
                    museum resembles a desert rose and offers an immersive journey through
                    Qatar’s history and heritage.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Interactive Exhibits, Heritage
                    Galleries, Audio-Visual Installations, Heritage Courtyard, Museum Gift
                    Shop, Desert Rose Café, Children’s Gallery.
                </p>,
            ],
        },
        {
            id: 9,
            title: "Al Zubarah Fort",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/Al%20Zubarah%20Fort.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A UNESCO World Heritage site offering a
                    glimpse into Qatar’s trading past with beautifully preserved ruins and
                    archaeological findings.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Archaeological Ruins, Historic Fort
                    Walls, Museum Exhibits, Desert Surroundings, Guided History Tours,
                    Photo Points, Heritage Walks.
                </p>,
            ],
        },
        {
            id: 10,
            title: "Aspire Zone (Doha Sports City)",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Aspire%20Zone.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Known as Qatar’s premier sports
                    destination. This wonderful place is home to world-class facilities
                    and lush green parks, ideal for outdoor and wellness activities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Aspire Park, Villaggio Mall, Torch
                    Tower, Sports Venues, Artificial Lake, Jogging Tracks, Family Zones,
                    Gondola Rides.
                </p>,
            ],
        },
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Doha-Based Itinerary Planning",
            desc: "Most programs are built around Doha due to the country’s compact size, with travel between key areas typically within 20–30 minutes, allowing multiple visits in a single day."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "2–3 Night Program Structuring",
            desc: "Qatar works best as a short-stay destination, usually planned for 2–3 nights—enough to cover city highlights, a desert experience, and leisure time without rushing."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Desert Safari Integration",
            desc: "Desert trips to Khor Al Adaid are typically planned as half-day or evening experiences, with full-day allocation only required for private or extended setups."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Hotel Location Planning",
            desc: "Hotel selection is focused on areas like West Bay, Msheireb, or The Pearl-Qatar, where location helps reduce travel time and improve overall itinerary flow."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Clustered Attraction Visits",
            desc: "Key attractions such as the Museum of Islamic Art, Souq Waqif, and the Corniche are grouped together to avoid unnecessary travel and optimize time."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Flexible Half-Day Planning",
            desc: "Itineraries often include free half-days for shopping or relaxation, aligning with the preference for a slower pace within short trips."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Event & Business Travel",
            desc: "Travel demand is frequently driven by exhibitions, conferences, and sporting events in Doha, with pricing and availability varying significantly during peak periods."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Stopover Program Usage",
            desc: "Qatar is commonly used as a stopover destination, with itineraries designed around flight timings rather than fixed day structures for maximum flexibility."
        },
    ];

    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/Qatar%20Banner.webp")'}
                text2={"Qatar"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={QatarSec1Data} />
          <IndiaSec2 countryCode="QA" />
            <IndiaSec3 data={topcitydata} name={"Qatar"} />
            <IndiaSec4
                data={data}
                heading={"Qatar Travel Programs & Services "}
            />
            <Footer />

        </>
    )


};